import React from 'react'
import { useMediaQuery, useTheme } from '@material-ui/core'

import { DieWrapper } from './Die'

const D100 = ({ disabled, info = {}, onDieChange }) => {
  const { amount = 0 } = info
  const theme = useTheme()
  const isSmall = useMediaQuery(theme.breakpoints.down('xs'))
  const isDarkMode = theme.palette.type === 'dark'

  const [ num, setNum ] = React.useState(100)

  const onClick = (value) => {
    const newAmount = Math.max(0, amount + value)
    onDieChange('d100', { amount: newAmount, num })
  }

  return (
    <DieWrapper disabled={disabled} isDarkMode={isDarkMode} isSmall={isSmall} onDieButtonClick={onClick} css={`
      flex-direction: column;
      /* Chrome, Safari, Edge, Opera */
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      input[type=number] {
        -moz-appearance: textfield;
      }
    `}>
      <div css={`font-weight: bold; margin-bottom: 2px;`}>
        {amount}
      </div>
      <input css={`max-width: 40px;`} type='number' min='2' value={num} onChange={({ target }) => {
        let val = target.value

        setNum(val)
        if (amount > 0) onDieChange('d100', { amount, num: val })
      }} />
    </DieWrapper>
  )
}

export default D100
